import { Eye, Edit2, Trash2 } from "lucide-react";
import type { ActionItem } from "@/components/ui/actions-dropdown";
import type { ActionSurface } from "./types";

export interface RoleActionsContext {
  surface: ActionSurface;
  isSystem: boolean;
  canEdit: boolean;
  canDelete: boolean;
  onView: () => void;
  onEdit: () => void;
  onDelete: () => void;
}

const L = (s: ActionSurface, list: string, detail: string) =>
  s === "list" ? list : detail;

export function buildRoleActions(ctx: RoleActionsContext): ActionItem[] {
  const { surface } = ctx;
  const items: ActionItem[] = [];
  if (surface === "list") {
    items.push({ label: "View Details", icon: Eye, onClick: ctx.onView });
  }
  if (ctx.canEdit && !ctx.isSystem) {
    items.push({ label: "Edit Role", icon: Edit2, onClick: ctx.onEdit });
  }
  if (ctx.canDelete && !ctx.isSystem) {
    items.push({
      label: L(surface, "Delete Role", "Delete Role"),
      icon: Trash2,
      onClick: ctx.onDelete,
      destructive: true,
    });
  }
  return items;
}
